function getWorkingDays() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const lastDayOfMonth = new Date(year, month + 1, 0);

  let workingDays = 0;

  for (let day = today.getDate(); day <= lastDayOfMonth.getDate(); day++) {
    const currentDay = new Date(year, month, day);
    const dayOfWeek = currentDay.getDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      workingDays++;
    }
  }

  return workingDays;
}

export default getWorkingDays
